export default {
  create: {
    title: 'Agregar',
    subtitle: 'Juegos',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Juego',
    button: {
      add: 'Nuevo juego',
    },
  },
  list: {
    title: 'Fences',
    subtitle: 'Lista',
    add: 'Nuevo juego',
  },
  card: {
    title: 'Fences',
    actions: 'Acciones',
  },
  table: {
    title: 'Juegos activos',
    searchPlaceholder: 'Buscar por algo...',
  },
  form: {
    name: {
      label: 'Nombre:',
      placeholder: 'Ej: Fences Nivel 1',
      invalid: 'El nombre es obligatorio',
    },
    showAnswer: {
      label: 'Mostrar respuesta',
    },
    colored: {
      label: 'Colorido',
    },
    columns: {
      label: 'Columnas:',
    },
    rows: {
      label: 'Filas:',
    },
    extraClues: {
      label: 'Pistas extras:',
      tooltipLine1:
        'El algoritmo define el mínimo de pistas para que el juego tenga solución única.',
      tooltipLine2:
        'Agregue pistas extras para hacer el juego más fácil para el usuario.',
    },
    invalidDimension:
      'Combinación inválida: fila y columna no pueden ser ambas pares. Al menos una debe ser impar.',
  },
  button: {
    generate: 'Generar juego',
  },
  sidebar: {
    exportHint: 'Debe guardar antes de exportar.',
    defaultFileName: 'fences',
  },
  status: {
    summary: '{total} pistas, siendo {base} fijas y {extra} extras',
    legendTitle: 'Leyenda de colores',
    fixedClues: '{count} pistas fijas',
    extraClues: '{count} pistas extras',
    answerVisible: 'Respuesta visible',
    answerHidden: 'Respuesta oculta',
  },
  alert: {
    generated: '¡Puzzle generado en {duration}s!',
    generateFailed: 'Error al generar el puzzle.',
    workerCritical: 'Error crítico interno en la generación.',
    gameSaved: '¡Juego guardado con éxito!',
    workerErrors: {
      pathGenerationFailed: 'Error al generar el camino.',
    },
  },
};
